<template>
    <div>
        <H1Heading>Privacy Policy</H1Heading>
        <div class="p-6">
            <div>
                <p class="mb-4">
                    Americanbookcompany.com, the wholly owned online platform of American Book Company, Inc. is
                    committed to protecting the privacy of our customer's personal information. In accordance with the
                    Family Education Rights and Privacy Act (FERPA) and the Children's Online Privacy Protection Act
                    (COPPA), all personal information submitted by student and teacher customers for use on the American
                    Book Company, Inc. website is for educational purposes only and not retained by American Book
                    Company, Inc. beyond the time necessary to provide services. American Book Company will not trade,
                    sell, or share any personal contact information entered on our site with any outside organization,
                    except where necessary for them to perform a technology support function for us. This applies with
                    respect to the information that we collect from the company web site, located at
                    <XLink href="/">www.americanbookcompany.com</XLink>
                    .
                </p>

                <p class="mb-4">
                    American Book Company, Inc. relies on the Institution’s consent in lieu of a parent in collecting
                    verifiable consent of students under the age of 13.
                </p>

                <p class="mb-4">
                    Approved amendments to this statement will be delivered to subscribers via email prior to being
                    posted at this URL and will become effective once posted. The absence of written disagreements from
                    subscribers about these intended changes and their continued use of this site following the notice
                    of any amendment, modification or change shall constitute acceptance thereof.
                </p>
            </div>

            <div>
                <h3 class="my-2 font-light">I. INFORMATION COLLECTED</h3>

                <p class="mb-4">
                    We collect non-personally identifiable information about you by tracking your activities through
                    your IP address, computer settings, or most-recently visited URL. We do not collect any personally
                    identifiable information (PII) except that which is voluntarily submitted. The types of information
                    that may be requested include first and last name, email address (optional), and student
                    identification number (optional). This personal information is collected in one of three ways -
                    either by direct student or teacher entry into the AmericanBookCompany account page, or by bulk
                    upload of information by an individual school or school district. All Personally Identifiable
                    Information is owned by the customers.
                </p>
            </div>

            <div>
                <h3 class="my-2 font-light">II. USE OF INFORMATION</h3>

                <p class="mb-4">
                    We will only use information for the purpose for which such information was provided. This personal
                    information is used solely for the recording and tracking of student results on assessment items
                    within the AmericanBookCompany website and can be accessed only by the individual student and
                    teachers or administrators at the school or district level. Your information may also be used to
                    contact you when necessary for site functionality, such as assigning resources, notifying students
                    of assessment results, and password reset functions. Users may opt-out of receiving future mailings
                    from us by following the instructions set forth in the opt-out section below.
                </p>

                <p class="mb-4">
                    Non-personal demographic and profile data is used to tailor your experience at our site, showing you
                    content we think educational professionals might be interested in.
                </p>

                <p class="mb-4">
                    Data is retained only for education purposes and for as long as you have an active account with us.
                    The customer may at any time ask that their account and related data be deleted. We will delete this
                    data within 30 days of such requests.
                </p>

                <div class="mb-4">
                    Anonymized, non-identifiable data may be used for the following purposes:
                    <ul class="mb-4 ml-12 list-decimal">
                        <li>
                            Analytics on student responses to identify problems with test content, such as unclear
                            questions or answers so test content can be improved.
                        </li>

                        <li>
                            Training AI models for automatic grading of answers for questions with variable answers i.e.
                            short-answer questions.
                        </li>
                    </ul>
                </div>

                <p class="mb-4"></p>
            </div>

            <div>
                <h3 class="my-2 font-light">III. USE OF IP ADDRESSES</h3>

                <p class="mb-4">
                    We use your IP Address to help diagnose problems with our server and to administer our website.
                </p>
            </div>

            <div>
                <h3 class="my-2 font-light">IV. USE OF COOKIES</h3>

                <p class="mb-4">
                    When you view our website, we might store some information on your computer. This information will
                    be in the form of a "cookie" or similar file. Cookies are small pieces of information stored on your
                    hard drive, not on our site. Cookies do not spy on you or otherwise invade your privacy, and they
                    cannot invade your hard drive or steal information. Rather, they help you navigate our website as
                    easily as possible. We use cookies to deliver content specific to your interests and to prevent you
                    from re-entering all of your registration data at each connection.
                </p>

                <div class="mb-4">
                    Types of cookies we use:
                    <ul class="mb-4 ml-12">
                        <li>
                            Essential cookies: These help make a website usable by enabling basic functions like page
                            navigation and access to secure areas of the website. The website cannot function properly
                            without these cookies.
                        </li>

                        <li>
                            Analytics cookies: These help the website operator understand how its website performs, how
                            visitors interact with the site, and whether there may be technical issues.
                        </li>
                    </ul>
                </div>
            </div>

            <div>
                <h3 class="my-2 font-light">V. PARENTAL RIGHTS</h3>

                <p class="mb-4">
                    American Book Company, Inc. requires only the collection of the first and last name of each student
                    for participation in online assessment activities. The only other personal information requested by
                    American Book Company, Inc. is the student ID Number and Email; this information is optional and
                    site usage is fully functional without this information. Schools or districts may require this
                    information for tracking purposes. The parent/guardian of each child is capable of reviewing their
                    child's personal information with the use of the student's username and password. Teachers can make
                    corrections and changes to their students’ names, ID numbers, and email addresses within
                    AmericanBookCompany.
                </p>

                <p class="mb-4">
                    Parents/Guardians may request to review, delete, or refuse collection of their child's personal
                    information directly with the school or school district. The schools will be responsible for
                    communicating deletion requests to American Book Company, Inc.
                </p>

                <div>
                    <h3 class="my-2 font-light">VI. USE OF GOOGLE & MICROSOFT APIS</h3>

                    <p class="mb-4">
                        You may log in to americanbookcompany.com using another service such as your Google or Microsoft
                        Account. If you do, we use that service to verify your identity and we store your OAuth token
                        for the purpose of logging you in via the "Sign In with Google" or "Sign In with Microsoft"
                        buttons. This information is stored and transmitted always via an encrypted channel.
                    </p>
                </div>

                <div>
                    <h3 class="my-2 font-light">VII. SECURITY</h3>

                    <p class="mb-4">
                        Our site has industry-standard security measures in place to protect the loss, misuse, and
                        alteration of the information under our control. While there is no such thing as "perfect
                        security" on the Internet, we will take all reasonable steps to ensure the safety of your
                        personal information.
                    </p>

                    <p class="mb-4">
                        AmericanBookCompany servers are cloud hosted-on AWS infrastructure. This allows Amazon to
                        maintain the security updates of their platforms and services which are used by
                        AmericanBookCompany along with other AWS customers. AmericanBookCompany servers receive
                        automated weekly security updates and can receive faster updates in cases of critical
                        vulnerabilities when they are detected and updated by Amazon’s infrastructure teams.
                    </p>

                    <p class="mb-4">
                        AmericanBookCompany’s web, content, and database servers are protected behind both AWS’s
                        firewalls and Cloudflare’s industry-leading WAF, proxy, and security services. Cloudflare
                        monitors traffic going to AmericanBookCompany servers and provides detection, mitigation,
                        alerting, and blocking for traffic that is identified as a threat.
                    </p>

                    <p class="mb-4">
                        AmericanBookCompany’s code is scanned weekly for vulnerabilities and reports are provided to the
                        development team for patching and updating. Once applied, these updates are deployed through an
                        automated deployment process which allows us to quickly respond to code, package, and dependency
                        vulnerabilities in code.
                    </p>
                </div>

                <div>
                    <h3 class="my-2 font-light">VIII. OTHER WEBSITES; LINKS</h3>

                    <p class="mb-4">
                        Americanbookcompany.com, in some states where educational standards require audio or video
                        questions in assessments, will have embedded audio or video files created by ABC and hosted at
                        external sites. These embedded files may contain links to our material at those external sites.
                        American Book Company, Inc. is not responsible for the privacy practices or the content of such
                        sites.
                    </p>
                </div>

                <div>
                    <h3 class="my-2 font-light">IX. CORRECT; UPDATE</h3>

                    <p class="mb-4">
                        American Book Company, Inc. allows teacher users the option to change or modify information
                        previously provided, such as names, email addresses, and student ID numbers. Additional changes
                        may be made through the following methods:
                    </p>

                    <ol class="mb-4 ml-12">
                        <li>
                            E-mail the information to
                            <XLink href="mailto:contact@americanbookcompany.com">contact@americanbookcompany.com</XLink>
                        </li>

                        <li>
                            Call
                            <XLink href="tel:18882645877">1-888-264-5877</XLink>
                        </li>
                    </ol>
                </div>

                <div>
                    <h3 class="my-2 font-light">X. CHOICE; OPT-OUT</h3>

                    <p class="mb-4">
                        Educators may receive occasional marketing messages from American Book Company, Inc. You may
                        opt-out of receiving marketing communications from us by the following means:
                    </p>

                    <ol class="mb-4 ml-12">
                        <li>
                            Send an e-mail to
                            <XLink href="mailto:contact@americanbookcompany.com">contact@americanbookcompany.com</XLink>
                        </li>

                        <li>
                            Call
                            <XLink href="tel:18882645877">1-888-264-5877</XLink>
                        </li>

                        <li>Follow the unsubscribe link at the bottom of the email.</li>
                    </ol>

                    <p class="mb-4">
                        You will still receive transactional emails such as receipts, and messages related to the access
                        and use of americanbookcompany.com.
                    </p>
                </div>

                <div>
                    <h3 class="my-2 font-light">XI. SUCCESSION</h3>

                    <p class="mb-4">
                        In the event of the sale of the company, successor entities remain bound to the processes and
                        policies defined in this Privacy Policy document.
                    </p>
                </div>

                <div>
                    <h2 class="mb-2 mt-8 text-3xl">CONTACTING US:</h2>

                    <p class="mb-4">
                        If you have any questions about this privacy statement, the practices of this site, or your
                        dealings with this website, you can contact us at
                        <XLink href="mailto:contact@americanbookcompany.com">contact@americanbookcompany.com</XLink>
                        .
                    </p>
                </div>

                <div>
                    <h2 class="mb-2 mt-8 text-3xl">DATA & PRIVACY FAQS</h2>
                </div>

                <div>
                    <h3 class="my-2 font-light">HOW DO YOU STORE STUDENT DATA?</h3>

                    <p class="mb-4">
                        We store student data in an encrypted form and only transmit student data across encrypted
                        channels.
                    </p>
                </div>

                <div>
                    <h3 class="my-2 font-light">DO YOU SHARE DATA WITH OTHER COMPANIES?</h3>

                    <p class="mb-4">
                        American Book Company, Inc. will not trade, sell, or share any personal contact information
                        entered on our site with any outside organization, except where necessary for the development
                        and administration of the website.
                    </p>
                </div>

                <div>
                    <h3 class="my-2 font-light">
                        IS MY DATA SECURE? DOES IT MEET MY DISTRICT/STATE SECURITY GUIDELINES?
                    </h3>

                    <p class="mb-4">
                        American Book Company, Inc. is committed to protecting the privacy of our customer's personal
                        information. Security compliance requirements can differ by state, county, and district. Please
                        feel free to contact us at contact@americanbookcompany.com with any specific security questions
                        you may have.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Index",
};
</script>

<style scoped></style>
